export const primaryColorTextField = {
  marginTop: "5px",
  "& .MuiOutlinedInput-root": {
    color: "#000",
    borderColor: "#44a99a",
    borderWidth: "1px",
    backgroundColor: "transparent",
    boxShadow: "1px 1px 5px rgba(35, 35, 35, 0.05)",
    "& fieldset": {
      borderColor: "#44a99a",
      borderWidth: "1px",
      color: "#000",
      borderRadius: "8px",
    },
    "&:hover fieldset": {
      borderColor: "#44a99a",
      borderRadius: "8px",
      borderWidth: "1px",
      color: "#000",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#44a99a",
      borderRadius: "8px",
      borderWidth: "2px",
      color: "#000",
    },
  },
  "& label.Mui-focused": {
    color: "#44a99a",
  },
  "& label": {
    color: "#44a99a",
  },
};
